import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const apiUrl1 = process.env.REACT_APP_ASSETS_API_URL;
const apiUrl2=process.env.REACT_APP_ADMIN_API_URL;
const header={
  'Content-Type': 'application/json; charset=UTF-8',
  "Accept": "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  "Authorization": getCookie("mawalog")
}



export const createCheckListApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`checklist`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getEmployeeListApi = async (term) => { 
  try {
    const response = await axios.get(
      adminApiUrl+`get_employee?term=`+term,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getLocationListApi = async (term) => { 
  try {
    const response = await axios.get(
      adminApiUrl+`get_location?term=`+term,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const createGateApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`gate`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const createWhatsappTemplateApi = async (data) => {  
  try {
    const response = await axios.post(
      adminApiUrl+`whatsapp_template`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const updateWhatsappTemplateApi = async (data,id) => {  
  try {
    const response = await axios.put(
      adminApiUrl+`whatsapp_template/`+id,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};


export const getDeleteWhatsAppTemp = async (id) => {
 
  try {
    const response = await axios.delete(
      adminApiUrl+`whatsapp_template/delete/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const getWhatsappTemplateDetailsApi = async (id) => { 
  try {
    const response = await axios.get(
      adminApiUrl+`whatsapp_template/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const getDeleteVehicleType = async (id) => {
 
  try {
    const response = await axios.delete(
      apiUrl+`vehicletype/delete/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getVehicleTypeDetailsApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`vehicletype/get/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const createVehicleTypeApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`vehicletype`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateVehicleTypeApi = async (data,id) => {  
  try {
    const response = await axios.put(
      apiUrl+`/vehicletype/`+id,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};

export const getDeletePOVApi = async (id) => {
 
  try {
    const response = await axios.delete(
      apiUrl+`visit/delete/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getPOVDetailsApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`visit/get/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const createPOVApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`visit`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updatePOVApi = async (data,id) => {  
  try {
    const response = await axios.put(
      apiUrl+`visit/`+id,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};

export const getDeleteCheckListApi = async (id) => {
 
  try {
    const response = await axios.delete(
      apiUrl+`checklist/delete/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getCheckListDetailsApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`checklist/get/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateCheckListApi = async (data,id) => {  
  try {
    const response = await axios.put(
      apiUrl+`checklist/`+id,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};


export const getDeleteTemplate = async (id) => {
 
  try {
    const response = await axios.delete(
      apiUrl+`email_template/delete/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const createTemplateApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`email_template`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const updateTemplateApi = async (data,id) => {  
  try {
    const response = await axios.put(
      apiUrl+`email_template/`+id,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};
export const getTemplateDetailsApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`email_template/get/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateAcknowledgement = async (id,data) => {  
  try {
    const response = await axios.post(
      apiUrl+`visitors/acknowledge/`+id,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getFAQListApi = async () => { 
  try {
    const response = await axios.get(
      adminApiUrl+`help?application=Gate`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
